// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelEnableLink-Message_cls1__Xvl9Y","cls2":"PaymentChannelEnableLink-Message_cls2__6qyqk PaymentChannelEnableLink-Message_cls1__Xvl9Y"};